import * as LucideIcons from "lucide-react";
import ToolCard from "./ToolCard";
import Header from "../../User/Navbar";
import Image from "../../../Static/Models/tools.svg";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Footer from "./Footer";
import Loader from "../../Loader/Loader";

export default function ToolsPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchtools = async () => {
    const url = "https://rohan-tax-services.onrender.com/api/auth/fetchtool";

    try {
      setLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (response.ok) {
        setData(result);
      } else {
        toast.error(result.msg || "Failed to fetch tools");
      }
    } catch (error) {
      toast.error("An error occurred while fetching tools");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchtools();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid gap-8 lg:grid-cols-2 items-center mb-12">
            {/* Text Section */}
            <div>
              <h1 className="text-5xl font-bold pb-4">
                Tax
                <span className="text-[#151C62] border-b-2 border-[#151C62] pb-1">
                  {" "}
                  Tools
                </span>
              </h1>
              <p className="mt-5 max-w-xl text-xl text-gray-500">
                Download our Excel-based tools to simplify your tax planning and
                management.
              </p>
            </div>
            <div>
              <Box
                component="img"
                src={Image}
                alt="Customer service illustration"
                sx={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </div>
          </div>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {data.map((tool) => (
              <ToolCard
                key={tool._id}
                tool={{
                  name: tool.name,
                  description: tool.description,
                  filePath: tool.link,
                }}
                Icon={LucideIcons[tool.iconname] || LucideIcons["File"]}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
